// const { addListener } = require("process");

//sticky header js
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $('body').addClass("sticky_header");
    }
  else{
	    $('body').removeClass("sticky_header");
  }
});

// custom js
$(document).ready(function () {
  $(".product-description-toggle").click(function () {
    $(this).parents('div.product-description').find('div.product-shortcode').toggleClass('product-description-open');
    $(this).toggleClass("active");

    if ($(this).text() == "READ MORE")
      $(this).text("READ LESS")
    else
      $(this).text("READ MORE");
  });

  $('.form-qty-add').click(function () {
    if ($(this).prev().val() < 500) {
      $(this).prev().val(+$(this).prev().val() + 1);
    }
  });
  $('.form-qty-sub').click(function () {
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
    }
  });


  var collectionSliderRow = $('.collection-slider-row');
  if (collectionSliderRow.length > 0) {
    collectionSliderRow.slick({
      infinite: false,
      accesibility: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      slidesToShow: 3,
      slidesToScroll: 1
    });
  }

  //   custom featured colletion section slider
  var featuredCollectionSlider = $('.featured-collection-slider');
  if (featuredCollectionSlider.length > 0) {
    featuredCollectionSlider.slick({
      infinite: true,
      accesibility: false,
      draggable: false,
      swipe: true,
      touchMove: true,
      appendArrows: '.featured-product-content-wrapper .cust-slider-arrows',
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }

  // product page slider
  var productGallerySlider = $('.product-gallery--slider');
  if (productGallerySlider.length > 0) {
    productGallerySlider.slick({
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            dots: false,
            arrows: false,
          }
        }
      ]
    });
  }

  // product page thumb slider
  var productSliderThumbs = $('.cust-product-slider-thumbs');
    if (productSliderThumbs.length > 0) {
    productSliderThumbs.slick({
      slidesToShow: 6,
      infinite: true,
      asNavFor: '.product-gallery--slider',
      dots: false,
      centerMode: false,
      slidesToScroll: 1,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 5,
            dots: false,
            arrows: false,
          }
        }
      ]
    });
  }

  // collection accordion js     
  $('.faq-que').click(function () {
    $(this).parent().toggleClass('active');
    $(this).siblings('.faqs-ans').slideToggle('300');
  });

  // collection page description js
  $('.read-more-collection').on('click', function () {
    $('#truncated').fadeOut(300, function () {
      $('#fullDescription').fadeIn(500);
    })
  });

  $('.read-less-collection').on('click', function () {
    $('#fullDescription').fadeOut(300, function () {
      $('#truncated').fadeIn(500);
    })
  });

  //   checkout page checkbox
  $(document).on('click', '.AuthorityToLeavePopup , .DoNotLeavePopup', function () {
    var leave = $('.AuthorityToLeavePopup'),
      noteave = $('.DoNotLeavePopup');
    if ($(leave).is(':checked')) {
      $('#cartCheckoutButtonPopup').removeAttr('disabled');
    } else if ($(noteave).is(':checked')) {
      $('#cartCheckoutButtonPopup').removeAttr('disabled');
    } else {
      $('#cartCheckoutButtonPopup').attr('disabled', 'disabled');
    }
  });
});

// product page metafiled accordion

$('.accordion-title').click(function(){
  $(this).siblings().slideToggle(300);
  $(this).parent().toggleClass('active');
});

//header megamenu js
var headerHeight = $('header').height();
var accountmentHeight = $('#shopify-section-static-announcement').height();
var megaNavHeight = (headerHeight + accountmentHeight);
$('.mega-nav-wrapper').css('top', megaNavHeight);
$(window).on('scroll', function(){
  if( $(window).scrollTop() >=  41){
    $('.mega-nav-wrapper').css('top', headerHeight);
  }else{
    $('.mega-nav-wrapper').css('top', megaNavHeight );
  } 
});

$('.navmenu-link-custom-megmenu1').mouseover(function(e){
    e.preventDefault();
    $('.mega-nav-wrapper').addClass('active');
  });
  
  $('.navmenu-depth-1 .navmenu-item a:not(.navmenu-link-custom-megmenu1)').mouseover(function () { 
    $('.mega-nav-wrapper').removeClass('active');
  });

  $('.site-logo').mouseover(function () { 
    $('.mega-nav-wrapper').removeClass('active');
  });


$('.mega-nav-wrapper').mouseover(function(e){
    e.preventDefault();
    $('.mega-nav-wrapper').addClass('active');
});

$('.mega-nav-wrapper').mouseleave(function (e) {
     $('.mega-nav-wrapper').removeClass('active');
});

